'use strict';

module.exports = require('asn1.js').define('Version', /* @this */function () {
  this.int();
});